import { addDays, format, startOfWeek } from "date-fns";
import { nl } from "date-fns/locale";

/** Dutch calendars start on Monday. Keep header and grid on the same offset. */
export const APPOINTMENT_WEEK_STARTS_ON = 1 as const;

const DUTCH_WEEKDAY_FORMAT = "EEEEEE";

export const getMondayFirstWeekdayHeaders = (
    referenceDate: Date = new Date(2026, 9, 1),
): string[] => {
    const start = startOfWeek(referenceDate, {
        locale: nl,
        weekStartsOn: APPOINTMENT_WEEK_STARTS_ON,
    });

    return Array.from({ length: 7 }, (_, index) =>
        format(addDays(start, index), DUTCH_WEEKDAY_FORMAT, { locale: nl }),
    );
};

export const getWeekdayColumnIndex = (
    date: Date,
    weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6 = APPOINTMENT_WEEK_STARTS_ON,
): number => {
    return (date.getDay() - weekStartsOn + 7) % 7;
};
